import * as React from "react";
const SvgMeeting = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 2.25A2.75 2.75 0 0 0 .25 5v10a.75.75 0 0 0 1.5 0V5c0-.69.56-1.25 1.25-1.25h18c.69 0 1.25.56 1.25 1.25v10a.75.75 0 0 0 1.5 0V5A2.75 2.75 0 0 0 21 2.25H3Zm4.509 7.2a4.752 4.752 0 0 1 8.982 0 .747.747 0 0 1 .509-.2 3.75 3.75 0 0 1 2.789 6.257 5.654 5.654 0 0 1 3.961 5.395c0 .468-.38.848-.848.848H1.192a.942.942 0 0 1-.942-.942 5.56 5.56 0 0 1 3.944-5.32A3.751 3.751 0 0 1 7 9.25c.196 0 .375.076.509.2ZM16.75 11c0-.1-.003-.198-.01-.296.082.03.169.046.26.046a2.25 2.25 0 0 1 0 4.5h-.379a6.6 6.6 0 0 0-1.48-.686A4.739 4.739 0 0 0 16.75 11Zm-9.49-.296a.747.747 0 0 1-.26.046A2.247 2.247 0 0 0 4.75 13 2.25 2.25 0 0 0 7 15.25h.379a6.6 6.6 0 0 1 1.48-.686 4.739 4.739 0 0 1-1.6-3.86Zm12.46 9.546a6.6 6.6 0 0 0-1.41-3.495 4.154 4.154 0 0 1 3.89 3.495h-2.48Zm-6.602-4.5a5.133 5.133 0 0 1 5.093 4.5H5.79a5.133 5.133 0 0 1 5.093-4.5h2.236Zm-7.425 1.002A6.6 6.6 0 0 0 4.28 20.25H1.788a4.059 4.059 0 0 1 3.905-3.498ZM15.25 11a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgMeeting;
